import { useTranslation } from "react-i18next"
import Section from "components/layout/section"
import PageTitle from "features/navigation/pageTitle"
import UserAvatar from "@/components/user/userAvatar"
import RightSidebar from "@/components/sidebar/right/RightSidebar"
import Button from "@/components/inputs/button"
import { ReactComponent as ChevronRightIcon } from "assets/icons/chevron_right.svg"
import { ReactComponent as DeleteIcon } from "assets/icons/delete.svg"
import useAuth from "@/hooks/useAuth"
import { AuthenticationMethod } from "@/types"
import LegalLinks from "@/components/legal/LegalLinks"

const AccountPage = () => {

    const { t } = useTranslation()

    const {
        getAuthenticationMethod
    } = useAuth()

    return (
        <>
            <PageTitle title={t('titleAccount')} />
            <Section>
                <UserAvatar showName={true} />
            </Section>
            <Section design="card-grid-large">
                <Section design="card">
                    <h2>{t("titleGeneralSettings")}</h2>
                    <p>{t("descriptionGeneralSettings")}</p>
                    <Button wideOnMobile to="/account/general-settings" design="primary"><ChevronRightIcon /><span>{t('buttonEditGeneralSettings')}</span></Button>
                </Section>
                <Section design="card">
                    <h2>{t("titleAvatarSettings")}</h2>
                    <p>{t("descriptionAvatarSettings")}</p>
                    <Button wideOnMobile to="/account/avatar-settings" design="primary"><ChevronRightIcon /><span>{t('buttonEditAvatarSettings')}</span></Button>
                </Section>
                {getAuthenticationMethod == AuthenticationMethod.password &&
                    <Section design="card">
                        <h2>{t("titleSecurity")}</h2>
                        <p>{t("descriptionSecurity")}</p>
                        <Button wideOnMobile to="/account/security-settings" design="primary"><ChevronRightIcon /><span>{t('buttonEditSecuritySettings')}</span></Button>
                    </Section>
                }
                <Section design="card">
                    <h2>{t("titleLegal")}</h2>
                    <p>{t("descriptionLegal")}</p>
                    <LegalLinks />
                </Section>
                <Section design="card">
                    <h2>{t("titleDeleteAccount")}</h2>
                    <p>{t("descriptionDeleteAccount")}</p>
                    <Button wideOnMobile to="/account/delete" design="danger"><DeleteIcon /><span>{t('buttonDeleteAccount')}</span></Button>
                </Section>
            </Section>
            <RightSidebar />
        </>
    )
}

export default AccountPage

